import { useRef } from "react";
import { useAlerts } from "../../contexts/AlertsContext";
import { useApiClient } from "../../contexts/ApiClientContext";
import Button from "./button/Button";
import ButtonAction from "./button/ButtonAction";
import DialogWindowType from "./dialog_window/DialogWindowType";
import AlertMessageType from "./alert_message/AlertMessageType";
import APIEndPoints from "../../utils/APIEndPoints";

interface IReportButtonProps {
  entityType: string;
  entityName: string;
  entityId: number;
  label?: string;
  className?: string;
}

function ReportButton({
  entityType,
  entityName,
  entityId,
  label = "Report Inappropriate Content",
  className = "",
}: IReportButtonProps) {
  const alertsManager = useAlerts();
  const apiClient = useApiClient();
  const reportMessageRef = useRef<string>("");

  const handleReport = () => {
    let report_message =
      `This is an automated message generated from a content report. A user has reported the following ${entityType} as containing inappropriate content: ` +
      entityName +
      ` (ID: ${entityId})`;

    report_message += "\n\n Reported reason: \n\n ";
    report_message += reportMessageRef.current;

    const body = {
      category: "board_member",
      message: report_message,
    };

    apiClient
      ?.post({
        url: APIEndPoints.EMAILS.NEW,
        body: body,
      })
      .then(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.SUCCESS,
          message: "Report submitted successfully. Our moderation team will review it shortly.",
        });
      })
      .catch(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.ERROR,
          message: "Failed to submit report. Please try again later.",
        });
      });
  };

  return (
    <Button
      label={label}
      purpose={ButtonAction.INFO}
      onClick={() => {
        alertsManager.showDialogWindow({
          type: DialogWindowType.CONTACTFORM,
          message: "Please describe why you are reporting this content as inappropriate:",
          cancelLabel: "Cancel",
          confirmLabel: "Submit Report",
          onConfirm: () => handleReport(),
          onUserMessageChange: (msg) => {
            reportMessageRef.current = msg;
          },
        });
      }}
      className={`!bg-amber-500 hover:!bg-amber-600 ${className}`}
    />
  );
}

export default ReportButton;
